import React from 'react';
import { homepageClients } from './homepageContent';

const ClientLogos = () => (
  <section className="home-client-section" aria-labelledby="home-client-title">
    <div className="auto-container">
      <div className="sec-title centered">
        <div className="title">OUR CLIENT WORK</div>
        <h2 id="home-client-title">Businesses &amp; Organizations We&apos;ve Worked With</h2>
        <div className="text">
          Websites and mobile applications delivered for organizations, service brands and
          growing businesses across India and Oman.
        </div>
      </div>

      <div className="home-client-grid">
        {homepageClients.map((client) => (
          <a
            className="home-client-card"
            href={client.href}
            target="_blank"
            rel={client.isOwned ? 'noopener' : 'noopener noreferrer nofollow'}
            referrerPolicy={client.isOwned ? 'origin-when-cross-origin' : undefined}
            key={client.name}
            aria-label={`Visit ${client.name} website (${client.location})`}
          >
            <span className={`home-client-logo-stage${client.brandTheme ? ` home-client-logo-stage--${client.brandTheme}` : ''}`}>
              {client.logo ? (
                <span className={`home-client-logo-frame ${client.logoVariant}`}>
                  <img src={client.logo} alt={`${client.name} logo`} className="home-client-logo" loading="lazy" />
                </span>
              ) : (
                <span className="home-client-brand-mark" aria-hidden="true">{client.brandMark}</span>
              )}
            </span>
            <span className="home-client-details">
              <span className="home-client-name">{client.name}</span>
              <span className="home-client-meta">
                <span className="home-client-classification">
                  <span className="home-client-work-type">{client.workType}</span>
                  <span className="home-client-location">
                    <i className="fa fa-map-marker" aria-hidden="true"></i>{client.location}
                  </span>
                </span>
                <span className="home-client-visit" aria-hidden="true">Visit <i className="fa fa-external-link"></i></span>
              </span>
            </span>
          </a>
        ))}
      </div>

      <div className="home-client-note">
        <span className="home-client-note-icon" aria-hidden="true"><i className="fa fa-briefcase"></i></span>
        <p><strong>A selected view of our work.</strong> Our broader project experience includes websites, business software, mobile applications, automation and digital growth engagements.</p>
      </div>
    </div>
  </section>
);

export default ClientLogos;
